export default  {
  bindings: {
    class: '@',
    id: '<'
  },
  controller: 'auditController',
  template: require('../views/audits.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/components/audits.component.js